import React from 'react';
import FadeIn from './FadeIn';
import corporateImg from '../assets/images/IMG_0800.JPG';
import foundersImg from '../assets/images/IMG_1054.JPG';
import studentsImg from '../assets/images/IMG_0649.JPG';
import diasporaImg from '../assets/images/IMG_1423.JPG';

const reasons = [
  {
    num: '35%',
    label: 'CORPORATE PROFESSIONALS',
    text: 'Employees at SMEs, multinationals and public sector organisations — the most commercially valuable audience in Cameroon.',
    image: corporateImg,
  },
  {
    num: '25%',
    label: 'ENTREPRENEURS & FOUNDERS',
    text: 'Active business owners, startup founders and freelancers ready to scale, partner, and access global markets.',
    image: foundersImg,
  },
  {
    num: '25%',
    label: 'STUDENTS & GRADUATES',
    text: 'University students and recent graduates entering the workforce — the next generation of Cameroonian leaders.',
    image: studentsImg,
  },
  {
    num: '15%',
    label: 'DIASPORA & INTERNATIONALS',
    text: 'Cameroonian diaspora and international professionals actively looking to invest, mentor, and connect back to Cameroon.',
    image: diasporaImg,
  },
];

export default function WhyAttend() {
  return (
    <section className="why-attend">
      <div className="container">
        <FadeIn>
        <div className="section-heading-row">
          <h2 className="section-heading-xl">WHO<br />ATTENDS?</h2>
          <div className="section-sub">
            A deliberately curated audience — the most commercially valuable professional demographic in Cameroon.
          </div>
        </div>
        </FadeIn>
        <FadeIn delay={1}>
        <div className="why-attend__grid">
          {reasons.map((r) => (
            <div className="why-card" key={r.num}>
              <div className="why-card__image" style={{ backgroundImage: `url(${r.image})` }} />
              <div className="why-card__content">
                <div className="why-card__label">{r.label}</div>
                <p className="why-card__text">{r.text}</p>
              </div>
              <div className="why-card__number">{r.num}</div>
            </div>
          ))}
        </div>
        </FadeIn>
      </div>
    </section>
  );
}
